import { usingGet } from '@ocean/api'

export const getSurveys = () => usingGet('Search/Library/Surveys', { useProxy: true })
